import React, { useState, useEffect, useCallback, useRef } from 'react';
import styled from 'styled-components';
import { Input, Button, Table } from 'antd';
import axios from 'axios';
import * as _ from 'lodash';
import Breadcrumb from '../Breadcrumb';

const DocumentBrowser = ({folderId, onDoubleClick, onTemplateSelect, onFolderClick, selectedRowKeys, tableHeight}) => {

  const [data, setData] = useState([]);
  const [filter, setFilter] = useState('');
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({total: 0});
  const [breadcrumbData, setBreadcrumbData] = useState([]);

  const searchInputRef = useRef(null);

  const getDocuments = useCallback((query) => {

    let qs = `folderID=${folderId}` +
                '&sortField=FileName' +
                '&sortDirection=asc' +
                '&take=50' +
                `&skip=${query.skip}` +
                `&page=${query.current}` +
                '&pageSize=50';

    query.filterText && (qs += `&filterText=${encodeURIComponent(query.filterText)}`)

    axios.get(`api/Documents/GetDocuments?${qs}`).then(res => {
      setPagination({total: res.data.TotalRows})
      setData(res.data.Data)
      setBreadcrumbData(res.data.Path.map(o => ({ path: o.path, breadcrumbName: o.breadcrumbName })))
      setLoading(false)
    })
  }, [folderId])

  useEffect(() => {
    setData([]);
    getDocuments({skip: 0, current: 1});
  }, [folderId, getDocuments])
  
  const handleSearch = (dataIndex, selectedKeys, confirm) => {
    confirm();
  };

  const handleReset = (clearFilters, confirm) => {  
    clearFilters();
    confirm();
  };

  const getColumnSearchProps = (columnTitle, dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            searchInputRef.current = node;
          }}
          placeholder={`Filter ${columnTitle}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(dataIndex, selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(dataIndex, selectedKeys, confirm)}
          style={{ width: 90, marginRight: 8 }}
        >
          Apply
        </Button>
        <Button onClick={() => handleReset(clearFilters, confirm)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    onFilterDropdownOpenChange: visible => {
      if (visible) {
        setTimeout(() => searchInputRef.current?.select());
      }
    }
  });

  const handleTableChange = (paging, filters, sorter) => {

    const pager = { ...paging };
    pager.current = paging.current;
    setPagination(pager);

    const filterText = filters?.FileName ?? '';

    const query = {
      ...pager,
      skip: (paging.current - 1) * paging.pageSize,
      filterText
    }

    setFilter(filterText);

    getDocuments(query);
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'FileName',
      key: 'FileName',
      filterSearch: true,
      ellipsis: true,
      ...getColumnSearchProps('Name', 'FileName'),
      filteredValue: filter,
      render: (text, item) => <div>
                          {item.ObjectType === 'fod' &&
                            <div>
                              <img width="24px" height="18px" style={{float: 'left', display: 'inline-block', marginRight: '10px', marginTop: '2px'}} src="/images/folder.png" />
                            </div>
                          }
                          {item.ObjectType !== 'fod' &&
                            <div className={`file-icon-small files-small-${item.ObjectType}`} style={{ marginRight: '10px', marginTop: '2px'}}></div>
                          }
                          {`${item.FileName}${item.ObjectType === 'fod' || !item.ObjectType ? '' : '.' + item.ObjectType}`}
                        </div>,
    },
    {
      title: 'Created',
      dataIndex: 'CreateDate',
      key: 'CreateDate',
      ellipsis: true
    }
  ];
  
  const navigateFolder = record => {
    setFilter('');
    if(record.ObjectType === 'fod') {
      onFolderClick(record.ID)
    }
  }
  
  const selectDocument = record => {
    if(record.ObjectType !== 'fod') {
      onTemplateSelect(record);
    }
  }
  
  return (
    <Container tableHeight={tableHeight}>
      <BreadcrumbContainer>
        <Breadcrumb
          paths={breadcrumbData}
          onClick={(o) => onFolderClick(o.path)} 
        />
      </BreadcrumbContainer>
      <Table
        rowKey="ID"
        size="small"
        loading={loading}
        columns={columns}
        dataSource={data}
        scroll={{y: tableHeight}}
        rowSelection={{
          hideSelectAll: true,
          selectedRowKeys: selectedRowKeys
        }}
        pagination={{
          position: ['bottomLeft'],
          total: pagination.total,
          showSizeChanger: false,
          //pageSizeOptions: [25, 50, 100],
          // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
          defaultPageSize: 50,
          defaultCurrent: 1
        }}
        onChange={handleTableChange}
        onRow={(record) => ({
          onClick: () => {
            if(record.ObjectType === 'fod') {
              navigateFolder(record)
            }
            else {
              selectDocument(record)
            }
          },
          onDoubleClick: () => onDoubleClick(record)
        })}
      />
    </Container>
  );
};

const Container = styled.div`
  .ant-pagination {
    margin: 10px 0 0 0 !important;
  }
  .ant-table-body {
    height: ${p => p.tableHeight + 'px'};
    overflow: auto;
    .ant-table-row {
      cursor: pointer;
    }
  }
`
const BreadcrumbContainer = styled.div`
  width: 100%;
  height: 50px;
  line-height: 50px;
`

export default DocumentBrowser;